"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskScope = exports.TaskStatus = exports.TaskType = void 0;
var TaskType;
(function (TaskType) {
    TaskType["VALIDATION"] = "validation";
    TaskType["DIFFUSION"] = "diffusion";
    TaskType["READ"] = "read";
})(TaskType || (exports.TaskType = TaskType = {}));
var TaskStatus;
(function (TaskStatus) {
    TaskStatus["NOT_STARTED"] = "not_started";
    TaskStatus["DUE_SOON"] = "due_soon";
    TaskStatus["OVERDUE"] = "overdue";
    TaskStatus["COMPLETED"] = "completed";
    TaskStatus["REJECTED"] = "rejected";
})(TaskStatus || (exports.TaskStatus = TaskStatus = {}));
var TaskScope;
(function (TaskScope) {
    TaskScope["MINE"] = "mine";
    TaskScope["ALL"] = "all";
})(TaskScope || (exports.TaskScope = TaskScope = {}));
//# sourceMappingURL=task.enum.js.map